import React, {useContext, useEffect} from 'react'
import headbandContext from 'contexts/headband'
import { Link } from 'react-router-dom'
import crumbContext from "contexts/crumbs"
import "./cfp.scss"
export default function Cfp() {
  const {setHeadband} = useContext(headbandContext)
  const {crumbs, setCrumbs} = useContext(crumbContext)
  useEffect(() => {
      setHeadband({
          title :  "Le congé de formation professionnelle",
          icon : "picto_conge_formation.svg",
          color : "bckRed"
      })
  }, [])
  return (
    <div id="cfp" className='page'>
      <img src="/cfp.png" alt="" />
      <Link to={"/accueil/drhf/fiche_contact"}
				className='cadreClique'
				onClick={() => {
          setCrumbs([
						{
							page :'/accueil',
							title : "Accueil"
						},
						{
							page : "/accueil/drhf",
							title : "Ma DRHF"
						},
						{
							page : "/accueil/drhf/fiche_contact",
							title : "Fiche contact"
						},
					])                       
                }} 
			></Link>
    </div>
  )
}
